export const GatewayActiveStateVariant = {
  Healthy: 'healthy',
  Offline: 'offline',
  Degraded: 'degraded',
  Unhealthy: 'unhealthy',
  Started: 'started',
} as const

export type GatewayActiveStateVariantValue = (typeof GatewayActiveStateVariant)[keyof typeof GatewayActiveStateVariant]

export type GatewayActiveStateProps = {
  className?: string
  label: string
  variant: GatewayActiveStateVariantValue
}
